/**
 * This is separated into its own export so it can be utilized without importing
 * all of Confetti and its types.
 */
export { asyncComponent } from "./src/helpers/asyncComponent";
